import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchPagesSuccess } from '../../../actions/pages.js';
import ItemBlock from  './ItemBlock';

const mapDispatchToProps = (dispatch) => {
    return {
        setPages: bindActionCreators(fetchPagesSuccess, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(ItemBlock);


// WEBPACK FOOTER //
// ./src/redux/components/molecules/ItemBlock/ItemBlockContainer.js